import { Directive } from '@angular/core';

@Directive({
  selector: '[appAccordion]'
})
export class AccordionDirective {

  constructor() { }

}
